import { GenericStencil } from "@brexhq/metal-generic-stencil";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

import { GridWidth } from "../Grid";

export const FooterLoadingStencils = () => (
  <GridWidth>
    <Container
      direction={"row"}
      gap={"xxlrg"}
      alignItems={"flex-start"}
      justifyContent={"space-between"}
      flexWrap={{ LRG: "nowrap", MED: "wrap", SML: "wrap" }}
    >
      <Container
        direction={"column"}
        gap={"sml"}
        display={{
          LRG: "block",
          MED: "block",
          SML: "none",
        }}
      >
        <GenericStencil width={95} height={30} />
      </Container>
      <Container direction={"column"} gap={"sml"}>
        <GenericStencil width={130} height={12} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
      </Container>
      <Container direction={"column"} gap={"sml"}>
        <GenericStencil width={130} height={12} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
      </Container>
      <Container direction={"column"} gap={"sml"}>
        <GenericStencil width={130} height={12} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
        <GenericStencil width={130} height={10} />
      </Container>
    </Container>
  </GridWidth>
);
